import styled from "styled-components";
import { scrollY_to_target } from "../utills/utills";
import { Arrow, Star } from "./svgs";

const Container = styled.div`
  position: absolute;
  display: flex;
  bottom: 45%;
  right: 6.5%;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  z-index: 1;
  cursor: pointer;
  @media (max-width : 1260px) {
    display: none;
  }
`;
interface IArrowProps {
  next_page: string;
}

function GridArrow({ next_page }: IArrowProps) {
  return (
    <Container onClick={() => scrollY_to_target(next_page)}>
      <Star />
      <Arrow />
    </Container>
  );
}

export default GridArrow;
